import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const gusto = defineConnector({
  identifier: "gusto",
  name: "Gusto",
  tagLine: "Payroll and HR platform",
  logo,
  protocol: "http",
  tags: ["it", "productivity"],
  defaultUrlPattern: () => "https://api\\.gusto\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create a Gusto Developer Application",
      items: [
        {
          kind: "markdown",
          content:
            "Visit the [Gusto Developer Portal](https://dev.gusto.com/) and create a new application to get your OAuth credentials.",
        },
      ],
    },
    {
      title: "Configure your app",
      items: [
        {
          kind: "markdown",
          content:
            "Copy and paste the following Redirect URI into your app settings:",
        },
        {
          kind: "copyable",
          label: "Redirect URI",
          value: "{API_URL}/connected-apps/oauth/gusto/callback",
        },
      ],
    },
    {
      title: "Enter your client credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          placeholder: "Paste your Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client Secret",
          placeholder: "Paste your Client Secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
    {
      title: "Authorize your Gusto account",
      items: [
        {
          kind: "markdown",
          content:
            "Finally, authorize your Gusto account to complete the connection.",
        },
        {
          kind: "oauth",
          dependsOn: [
            { kind: "oauthConnection", field: "clientId" },
            { kind: "oauthConnection", field: "clientSecret" },
          ],
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: () => "https://api.gusto.com/oauth/authorize",
    tokenEndpoint: () => "https://api.gusto.com/oauth/token",
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://api.gusto.com/v1/me",
  },
});
